import { render, staticRenderFns } from "./SharedChannelMoveInstanceSettings.vue?vue&type=template&id=0a6a8f06&scoped=true&"
import script from "./SharedChannelMoveInstanceSettings.vue?vue&type=script&lang=js&"
export * from "./SharedChannelMoveInstanceSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6a8f06",
  null
  
)

export default component.exports